import axios from "axios";
import { exchangeGoogleIdTokenWithAuthCode, getAcceptInvitationLinkUrl, getAcceptInvitationUrl, getDeclineInvitationUrl, getDeleteAccountUrl, getUpdateUserInterestsUrl, getUpdateUserProfilePictureUrl, getUpdateUserProfileUrl, getUserInvitationsUrl, getUserProfileByIdUrl, getUserProfileUrl, getUserSignUpStatusUrl, getVerifyInviteCodeUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class UserRepository {
    
    async getUserSignUpStatus() {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserSignUpStatusUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getUserProfile() {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserProfileUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getUserProfileById(userId) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserProfileByIdUrl(userId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async verifyInviteCode(code) {
        const session = await supabase.auth.getSession()
        try {
            const response = await axios.post(
                getVerifyInviteCodeUrl(),
                {
                    inviteCode: code
                },
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            );
            return response.status
        } catch (e) {
            return e.response.status
        }
    }

    async updateUserProfile(name) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getUpdateUserProfileUrl(),
            {
                name: name,
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async uploadProfilePicture(picture) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append(`image`, picture)
        const response = await axios.post(
            getUpdateUserProfilePictureUrl(),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async updateUserInterests(interests) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getUpdateUserInterestsUrl(),
            {
                interests: interests,
            },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async exchangeGoogleIdTokenWithAuthCode(authCode, redirectUri) {
        const response = await axios.post(
            exchangeGoogleIdTokenWithAuthCode(),
            {
                googleAuthorizationCode: authCode,
                redirectUri: redirectUri
            }
        );
        return response.data
    }

    async getUserPendingInvitations() {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserInvitationsUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async acceptInvitation(invitationId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getAcceptInvitationUrl(invitationId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async declineInvitation(invitationId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getDeclineInvitationUrl(invitationId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async acceptInvitationLink(invitationLinkId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getAcceptInvitationLinkUrl(invitationLinkId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async declineInvitationLink(invitationLinkId) {
        const session = await supabase.auth.getSession()
        await axios.post(
            getAcceptInvitationLinkUrl(invitationLinkId),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }

    async requestToDeleteAccount() {
        const session = await supabase.auth.getSession()
        console.log(`session access token is ${session.data.session.access_token}`)
        await axios.delete(
            getDeleteAccountUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }
}
